import { useAuthStore } from '../stores/auth'

export const getAuthHeader = (): { Authorization: string } => {
  const token = useAuthStore().token
  return { Authorization: 'Bearer ' + token }
}
